export default {
    canResendCode: true,
    timer: null,
}
